export enum ProductId {
  FollowUp = 1,
  Onsite,
  Online,
}
